import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My favorite serverless project",
  "description": "When's the last time your first project in a new technology was also your favorite? Doesn't happen very often ...🤔 It happened to me in November 2018.",
  "published": "2020-09-24T00:00:00.000Z",
  "hero": "./img/screenshot-1600964121683.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`When's the last time your first project in a new technology was also your favorite? Doesn't happen very often ...🤔`}</p>
    <p>{`It happened to me in November 2018.`}</p>
    <p>{`Pat Walls of `}<a parentName="p" {...{
        "href": "https://www.starterstory.com"
      }}>{`Starter Story`}</a>{` fame posed a challenge: Build a startup in 24 hours.`}</p>
    <p>{`Absolute mad man. There's no way.`}</p>
    <p>{`Is there ... what if? No, no that's crazy. But maybe ... no hell no. Unless ...`}</p>
    <p>{`I `}<em parentName="p">{`have`}</em>{` been paying someone $500/mo to do a boring task 👉 take my markdown, put images on imgur, screenshot tweets, code snippets, and youtube embeds, export to HTML and paste into a newsletter.`}</p>
    <p>{`That sounds automatable ...`}</p>
    <p>{`Fuck it, Pat Walls you're on!`}</p>
    <lite-youtube {...{
      "videoid": "sqlC1zNYG4M",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`12 hours later, `}<a parentName="p" {...{
        "href": "https://techletter.app"
      }}>{`TechLetter.App`}</a>{` was born. You see its output every time you read my email.`}</p>
    <p>{`And every day it feels like magic. 🧙‍♂️`}</p>
    <h2 {...{
      "id": ""
    }}>{`😍`}</h2>
    <p><img parentName="p" {...{
        "src": "/c86f85dd18f15a31181b6e85e037241f/TechLetterApp-showing-offgge7cj.gif",
        "alt": "TechLetterApp showing off"
      }}></img></p>
    <p>{`Write email in markdown. Paste into box on the left, get rendered HTML on the right. Basic markdown parsing and rendering. There's libraries for that.`}</p>
    <p>{`Here's where it gets cool 👇`}</p>
    <p>{`TechLetter.App uses an AWS Lambda to spin up a Chrome browser and take screenshots. Tweets, Youtube thumbnails, Instagram, code snippets, CodeSandbox, and a few more.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "800px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/88927095f0e76d87097f0f82da278007/5a190/How-TechLetterApp-takes-a-screenshot071c59.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "68.60986547085201%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'275\\'%20viewBox=\\'0%200%20400%20275\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M169%2024v31c-1%2010-1%2011%201%209l1-21V24h9l29%204-3%2031c0%203%200%203-6%203a159%20159%200%2000-26%202c-5%201-5%201-3%202h11l17-2c7%200%207%200%207%203-1%203%201%202%202-2l1-4%201-18a2165%202165%200%2000-1-18l-11-1c-12-3-29-3-29%200m-67%2019a186%20186%200%2001-67%200c0%204%2046%205%2072%200%204%200%204%200%204%202%200%203-1%204-11%208a191%20191%200%2000-25%2010v1c1%201%204%200%2012-4%2012-6%2020-9%2023-9%202%200%201%2013-2%2037-3%2020-4%2041-2%2041l1-11%203-32%202-28v-8l4-1%2017-3%2016-2a351%20351%200%2001-36%202v-4h-2l-9%201m-72%204v9a767%20767%200%20011%2086l8-2%2041-2c39-1%2035-1%2035-2l-3-1-33%202c-25%200-39%201-45%203l-1-36c0-50-1-64-3-57m166%2030c-2%200-3%202-3%202l-1-1c-1-2-1-2-2-1l2%206%202%208%201%203%202%203%203%208c1%203%201%203%201%201-1-3%200-3%202-4%204%200%205-2%202-2l-3-1-2-1-4-8c-3-9-4-11-2-9%203%202%2011%201%2011-2h-4l-4%201c-2%200-2%200-1-2l5-1%203-1c0-2-5-1-8%201m-16%2018c0%204-2%206-3%204s-2-2-3-1c-2%202-3%202-2%200l-1-1-4-1c-3-1-4%200-4%204%200%203%200%203-2%202-4-3-5-5-1-6l2-2-5%201c-3%202-1%208%203%208l2%202c0%203%201%203%203%200%201-3%202-3%205-3l5-1h1l6%201c5%200%206-2%201-4l-1-3-1-3c-1-1-1%200-1%203m124%2039v19c-2%2013-2%2023-1%2023l1-7%201-18c1-5%202-11%201-13v-3h18c19%201%2036%202%2040%204%203%200%204%202%202%2025-1%2018-2%2021-5%2020a951%20951%200%2001-1%202l7%201-1-1v-5a328%20328%200%20004-42c0-2-2-2-11-3-32-3-53-4-55-2m7%2014c1%206%200%206%2011%204%205-1%206-2%207-4%201-4-2-5-10-5h-8v5m13%2013c-3%201-4%203-1%203%201-1%202-1%201%201-1%206%204%206%2020%201l1-3c0-3%200-3-6-3l-9-1-6%202m-251%206l-25%201c-18%201-23%201-12%202h30l19-2c12%200%2012%201%207%207-4%205-4%207-1%207%202%200%202%200%202%202-6%2019-12%2055-9%2054l1-5c0-10%204-29%209-47%201-5%201-5%207-7l6-3c2-1-1-1-5%201-4%201-5%201-4-1l-1-1c-1%201-1%200-1-4l1-4-9-1-15%201m-44%2020c0%2015%200%2018-2%2028l-3%2020c0%2011%200%2011%2015%208l25-1c15%201%2027%200%2029-2%201-2-1-2-6%200l-22%201c-12-1-19-1-26%201-14%202-13%202-13-6l1-9%202-15c2-13%202-19%201-33s-2-9-1%208m22-8l-6%202h4c12-2%2025%201%2024%205l-2%209-1%207h-5c-4%200-5%200-4-2%200-4-2-7-5-7-2%200-9%205-8%206l4-2%204-3c2%200%203%203%203%205s-1%202-8%202l-8%201c0%201%208%202%2019%202h10v-4l1-9c3-9%203-9-3-11-7-2-13-2-19-1m154%2027c-3%204-3%204%201%204h7c0-2%203-1%205%201%201%201%201%201%203-1s2-2%204-1c1%202%202%202%203%200%202-1%202-1%202%201l1%203%201-4c0-6-1-7-3-3-2%203-4%203-4%200-1-3-3-2-4%201l-2%204v-4c0-5-2-5-5-1-2%202-3%203-4%202h-2l-1-1%201-1%201-2c0-2-2-1-4%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/88927095f0e76d87097f0f82da278007/ca0a1/How-TechLetterApp-takes-a-screenshot071c59.webp 223w", "/static/88927095f0e76d87097f0f82da278007/75680/How-TechLetterApp-takes-a-screenshot071c59.webp 445w", "/static/88927095f0e76d87097f0f82da278007/d00b9/How-TechLetterApp-takes-a-screenshot071c59.webp 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/88927095f0e76d87097f0f82da278007/e92b6/How-TechLetterApp-takes-a-screenshot071c59.png 223w", "/static/88927095f0e76d87097f0f82da278007/e66bf/How-TechLetterApp-takes-a-screenshot071c59.png 445w", "/static/88927095f0e76d87097f0f82da278007/5a190/How-TechLetterApp-takes-a-screenshot071c59.png 800w"],
                "sizes": "(max-width: 800px) 100vw, 800px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/88927095f0e76d87097f0f82da278007/5a190/How-TechLetterApp-takes-a-screenshot071c59.png",
                "alt": "How TechLetterApp takes a screenshot",
                "title": "How TechLetterApp takes a screenshot",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`How TechLetterApp takes a screenshot`}</figcaption>{`
  `}</figure></p>
    <p>{`Think about it – every time you paste a link, a few dozen steps go just right in a dance of magic:`}</p>
    <ol>
      <li parentName="ol">{`Markdown plugin recognizes a link`}</li>
      <li parentName="ol">{`Matches link to Regex of screenshottable stuffs`}</li>
      <li parentName="ol">{`Renders a `}<inlineCode parentName="li">{`<Screenshot >`}</inlineCode>{` React component`}</li>
      <li parentName="ol">{`Component uses `}<inlineCode parentName="li">{`useEffect`}</inlineCode>{` to make an API request`}</li>
      <li parentName="ol">{`DNS config maps request to my API Gateway`}</li>
      <li parentName="ol">{`API Gateway says `}<em parentName="li">{`"Oh, `}{`_`}{`that`}</em>{` lambda"`}{`_`}</li>
      <li parentName="ol">{`AWS Lambda spins up a whole new server`}</li>
      <li parentName="ol">{`That server runs my JavaScript function`}</li>
      <li parentName="ol">{`Function starts a Chrome browser`}</li>
      <li parentName="ol">{`Browser loads the link (another magical dance)`}</li>
      <li parentName="ol">{`My code uses browser JavaScript to find the correct DOM node to use`}</li>
      <li parentName="ol">{`Tells browser to take a screenshot of that node`}</li>
      <li parentName="ol">{`Uploads screenshot to S3 as a file`}</li>
      <li parentName="ol">{`Returns the URL as an API response`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`<Screenshot>`}</inlineCode>{` component renders image`}</li>
    </ol>
    <p>{`All this in 3 seconds for $0. 😳`}</p>
    <p>{`The future boggles the mind my friend. You can try it at this URL 👉 `}<a parentName="p" {...{
        "href": "https://pifc233qp6.execute-api.us-east-1.amazonaws.com/dev/embed?url=https://twitter.com/Swizec/status/1063847466196328448"
      }}>{`link to my AWS Lambda`}</a></p>
    <p>{`Before you ask: Yes, a lot has happened to this Lambda over the years. Fixes to how Chrome works, tweaks to screenshots, new features, cleaned up the codebase recently. It's been a fun project.`}</p>
    <p>{`Even got `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lambda-screenshot-as-a-service"
      }}>{`91 stars on GitHub`}</a>{` despite being hardcoded for my usecase and with a Readme so out of date it's hilarious. I should fix that 😅`}</p>
    <h2 {...{
      "id": "why-i-love-this-project"
    }}>{`Why I love this project`}</h2>
    <p>{`Sometimes you love things just because they're cool. You don't need an excuse to be a nerd.`}</p>
    <p>{`And it's saved me countless hours and almost $10,000 in outsourcing cost. So that's nice. 😇`}</p>
    <p>{`Not bad for a few hours of hacking and $0 in hosting cost huh?`}</p>
    <p>{`What would you build, if running server code was a breeze? Hit reply`}</p>
    <p>{`Cheers,
~Swizec`}</p>
    <p>{`PS: want to learn serverless in a focused setting without investing 2 years of pain and reading random blogposts? Join my `}<a parentName="p" {...{
        "href": "https://gum.co/pEmTq"
      }}>{`Serverless Workshop`}</a>{`, sales close tomorrow. `}<a parentName="p" {...{
        "href": "https://gum.co/wYpbg"
      }}>{`Also available in installments`}</a></p>
    <p>{`PPS: the distributed serverless data processing pipeline chomping through millions of events per day that I built at work sounds impressive on a resume, but it isn't `}<em parentName="p">{`cool`}</em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      